<template>
    <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-if="isValid('CanDraftExpenseBill') || isValid('CanAddExpenseBill') || isValid('CanEditExpenseBill')  ">
        <div class="row">
            <div class="col-md-12 " v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
                <div class="card">
                    <div class="card-body">

                        <div class="card-header p-0">
                            <h5>{{ $t('AddPurchaseBill.Bills') }}</h5>
                        </div>
                        <div class="row">

                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label> {{ $t('AddPurchaseBill.BillNo') }}: <span class="LabelColour"> *</span></label>
                                <div v-bind:class="{'has-danger' : $v.purchaseBill.registrationNo.$error}">
                                    <input :key="render" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" class="form-control" disabled v-model="purchaseBill.registrationNo" />
                                </div>

                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label>{{ $t('AddPurchaseBill.Date') }}: <span class="LabelColour"> *</span></label>
                                <div v-bind:class="{'has-danger' : $v.purchaseBill.date.$error}">
                                    <datepicker :key="render" v-model="$v.purchaseBill.date.$model"></datepicker>

                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label>{{ $t('AddPurchaseBill.DueDate') }}: <span class="LabelColour"> *</span></label>
                                <div v-bind:class="{'has-danger' : $v.purchaseBill.dueDate.$error}">
                                    <datepicker v-model="$v.purchaseBill.dueDate.$model"></datepicker>

                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">


                                <label>{{ $t('AddPurchaseBill.Account') }}: <span class="LabelColour"> *</span></label>
                                <accountdropdown v-model="purchaseBill.billerId"></accountdropdown>


                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label> {{ $t('AddPurchaseBill.Reference') }}:</label>
                                <input v-model="purchaseBill.reference" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                            </div>
                            <!--<div class="col-xs-12 col-sm-6 col-md-6 col-lg-4" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" >
                            <label>{{ $t('Product.TaxMethod') }} :</label>
                            <multiselect :options="options"  v-model="purchaseBill.taxMethod" :show-labels="false" v-bind:placeholder="$t('SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            </multiselect>
                        </div>-->
                        </div>

                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <PurchaseBillItem v-on:updatedailyExpenseRows="getupdatedailyExpenseRows"></PurchaseBillItem>
                            </div>
                        </div>
                        <div class="row">


                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <label>{{ $t('AddPurchaseBill.Narration') }}: </label>
                                <div v-bind:class="{'has-danger' : $v.purchaseBill.narration.$error}">
                                    <textarea class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" autofocus="autofocus" v-model="purchaseBill.narration" />
                                </div>
                                <span v-if="$v.purchaseBill.narration.$error" class="error text-danger">
                                    <span v-if="!$v.purchaseBill.narration.maxLength">{{ $t('AddPurchaseBill.DescriptionMaximumlength') }}</span>
                                </span>
                            </div>
                        </div>
                        <!--<div class="accordion" role="tablist" v-if="isValid('CanUploadExpenseBillAttachment')">
                            <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-1 variant="primary">{{ $t('AddPurchaseBill.Attachment') }}</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                        <import-attachment :purchase="purchaseBill" :show="attachments" @close="attachments = false" v-if="attachments" @billAttachments="billAttachments" :document="'Bills'" />
                                        <div>
                                            <div class="row">
                                                <div class="col-md-12 text-right">
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="attachments=true"> Upload</a>
                                                </div>
                                            </div>
                                            <div class=" table-responsive">
                                                <table class="table ">
                                                    <thead class="m-0">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>{{ $t('AddPurchaseBill.Date') }} </th>
                                                            <th>{{ $t('AddPurchaseBill.Description') }} </th>
                                                            <th>{{ $t('AddPurchaseBill.Attachment') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(contact,index) in purchaseBill.billAttachments" v-bind:key="index">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <th>{{getDate(contact.date)}}</th>
                                                            <th>{{contact.description}}</th>

                                                            <td>
                                                                <button class="btn btn-primary  btn-icon mr-2"
                                                                        v-if="contact.path != ''"
                                                                        v-on:click="DownloadAttachment(contact.path)">
                                                                    <i class="fa fa-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                        </div>-->
                        <div class="col-lg-12 col-md-12 col-sm-12">

                            <div v-if="purchaseBill.id == null || purchaseBill.id == '00000000-0000-0000-0000-000000000000'">
                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()"  v-if="isValid('CanUploadExpenseBillAttachment')">
                                    {{ $t('AddSaleOrder.Attachment') }}
                                </button>
                                <button class="btn btn-danger float-right mr-2" v-on:click="BackToList()">{{ $t('AddPurchaseBill.Cancel') }}</button>
                                <button class="btn btn-primary float-right mr-2" v-on:click="SaveDailyExpenseInformation('Approved')" v-if="isValid('CanAddExpenseBill')" :disabled="$v.$invalid || purchaseBill.purchaseBillItems.filter(x => x.description=='' && x.amount==0 && x.accountId=='').length > 0"><i class="far fa-save"></i>  {{ $t('AddPurchaseBill.SaveAndpost') }}</button>
                                <button class="btn btn-primary float-right mr-2" v-on:click="SaveDailyExpenseInformation('Draft')" v-if="isValid('CanDraftExpenseBill')" :disabled="$v.$invalid || purchaseBill.purchaseBillItems.filter(x => x.description=='' && x.amount==0 && x.accountId=='').length > 0"><i class="far fa-save"></i>  {{ $t('AddPurchaseBill.Save') }}</button>

                            </div>
                            <div v-else>
                                <button class="btn btn-primary mr-2 float-left" v-on:click="Attachment()"  v-if="isValid('CanUploadExpenseBillAttachment')">
                                    {{ $t('AddSaleOrder.Attachment') }}
                                </button>
                                <button class="btn btn-danger float-right mr-2" v-on:click="BackToList()">{{ $t('AddPurchaseBill.Cancel') }}</button>
                                <button class="btn btn-primary float-right mr-2" v-on:click="SaveDailyExpenseInformation('Approved')" :disabled="$v.$invalid"><i class="far fa-save"></i>  {{ $t('AddPurchaseBill.Updateandpost') }}</button>
                                <button class="btn btn-primary float-right mr-2" v-on:click="SaveDailyExpenseInformation('Draft')" :disabled="$v.$invalid"><i class="far fa-save"></i>  {{ $t('AddPurchaseBill.Update') }}</button>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <bulk-attachment :attachmentList="purchaseBill.attachmentList" :show="show" v-if="show" @close="attachmentSave" />

    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import moment from 'moment';
    //import Multiselect from 'vue-multiselect'

    import { required, maxLength } from 'vuelidate/lib/validators';
    export default ({
        mixins: [clickMixin],

        data: function () {
            return {
                purchaseBillItems: [],
                render: 0,
                show: false,
                attachment: false,
                attachments: false,
                language: 'Nothing',
                options: [],
                purchaseBill: {
                    id: '00000000-0000-0000-0000-000000000000',
                    registrationNo: '',
                    date: '',
                    dueDate: '',
                    taxMethod: '',
                    reference: '',
                    billerId: '',
                    purchaseBillItems: [],
                    billAttachments: [],
                    attachmentList: [],
                },

            }
        },
        validations: {
            purchaseBill:
            {
                registrationNo:
                {
                    required,
                    maxLength: maxLength(30)
                },
                date:
                {
                    required,
                },
                dueDate:
                {
                    required,
                },
                narration:
                {
                },
                purchaseBillItems:
                {
                    required,

                },


            }
        },
        methods: {
            Attachment: function () {
                this.show = true;
            },

            attachmentSave: function (attachment) {
                this.purchaseBill.attachmentList = attachment;
                this.show = false;
            },

            DownloadAttachment(path) {

                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var ext = path.split('.')[1];
                root.$https.get('/Contact/DownloadFile?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` }, responseType: 'blob' })
                    .then(function (response) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.' + ext);
                        document.body.appendChild(link);
                        link.click();
                    });
            },
            getDate: function (date) {


                return moment(date).format('LLL');

            },

            billAttachments: function (x) {

                var root = this;
                if (x != undefined && x != null && x != '') {
                    this.purchaseBill.billAttachments.push({
                        path: x.path,
                        date: x.date,
                        description: x.description
                    })
                }
                this.attachments = false;
                this.$swal.fire({
                    title: root.$t('AddPurchaseBill.SavedSuccessfully'),
                    text: root.$t('AddPurchaseBill.Saved'),
                    type: 'success',
                    confirmButtonClass: "btn btn-success",
                    buttonStyling: false,
                    icon: 'success',
                    timer: 1500,
                    timerProgressBar: true,

                });
            },
            languageChange: function (lan) {
                if (this.language == lan) {
                    if (this.purchaseBill.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/');
                    }
                    else {

                        this.$swal({
                            title: this.$t('AddPurchaseBill.Error'),
                            text: this.$t('AddPurchaseBill.ChangeLanguageError'),
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }


            },
            getupdatedailyExpenseRows: function (items) {
                this.purchaseBillItems = items;
                this.purchaseBill.purchaseBillItems = items;
            },
            AutoIncrementVoucherNo: function () {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https
                    .get('/Purchase/PurchaseBillAutoGenerateNo', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                        if (response.data != null) {
                            root.purchaseBill.registrationNo = response.data;
                        }
                    });
            },
            BackToList: function () {
                if (this.isValid('CanViewExpenseBill') || this.isValid('CanDraftExpenseBill')) {
                    this.$router.push({
                        path: '/PurchaseBill',
                        query: {
                            data: 'PurchaseBills'
                        }
                    })
                }
                else {
                    this.$router.go();
                }
                

            },
            SaveDailyExpenseInformation: function (value) {

                var root = this;
                this.purchaseBill.approvalStatus = value
                localStorage.setItem('active', value);

                var url = '/Purchase/SavePurchaseBillInformation';
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var prd = root.purchaseBill.purchaseBillItems.findIndex(x => x.amount == 0);
                if (prd >= 0) {
                    root.purchaseBill.purchaseBillItems.splice(prd, 1)
                }
                root.purchaseBill.date = root.purchaseBill.date + " " + moment().format("hh:mm A");
                root.purchaseBill.dueDate = root.purchaseBill.dueDate + " " + moment().format("hh:mm A");

                root.$https
                    .post(url, root.purchaseBill, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        root.info = response.data.bpi
                        this.$swal.fire({
                            title: root.$t('SavedSuccessfully'),
                            text: root.$t('Saved'),
                            type: 'success',
                            confirmButtonClass: "btn btn-success",
                            buttonStyling: false,
                            icon: 'success',
                            timer: 1500,
                            timerProgressBar: true,

                        });
                        if (this.isValid('CanViewExpenseBill') || this.isValid('CanDraftExpenseBill')) {
                            this.$router.push({
                                path: '/PurchaseBill',
                                query: {
                                    data: 'PurchaseBills'
                                }
                            })
                        }
                        else {
                            this.$router.go();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.$swal.fire(
                            {
                                icon: 'error',
                                title: this.$t('AddPurchaseBill.Error'),
                                text: this.$t('AddPurchaseBill.Error'),
                            });
                        root.errored = true
                    })
                    .finally(() => root.loading = false)
            },

        },
        created: function () {

            this.language = this.$i18n.locale;

            if (this.$route.query.data != undefined) {

                this.purchaseBill = this.$route.query.data;

            }


            this.$emit('input', this.$route.name);
        },

        mounted: function () {


            if (this.$route.query.data == undefined) {
                this.AutoIncrementVoucherNo();
                this.purchaseBill.date = moment().format('llll');
                this.render++;
            }



        }
    })

</script>